import { render } from "./product_list.vue?vue&type=template&id=354e81e1&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"

import "./product_list.vue?vue&type=style&index=0&id=354e81e1&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354e81e1"]])

export default __exports__